/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface BedConflictOccupant
 */
export interface BedConflictOccupant {
    /**
     *
     * @type {string}
     * @memberof BedConflictOccupant
     */
    lead_id?: string;
    /**
     *
     * @type {string}
     * @memberof BedConflictOccupant
     */
    first_name?: string | null;
    /**
     *
     * @type {string}
     * @memberof BedConflictOccupant
     */
    last_name?: string | null;
}

/**
 * Check if a given object implements the BedConflictOccupant interface.
 */
export function instanceOfBedConflictOccupant(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BedConflictOccupantFromJSON(json: any): BedConflictOccupant {
    return BedConflictOccupantFromJSONTyped(json, false);
}

export function BedConflictOccupantFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedConflictOccupant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
    };
}

export function BedConflictOccupantToJSON(value?: BedConflictOccupant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'lead_id': value.lead_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}
